<template>
  <div class="vrun-form-result-no-data">{{ $vt("Empty") }}</div>
</template> 
<script>
export default {
  translate25Context: "vrun_form",
  methods: {},
  props: ["value"],
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.vrun-form-result-no-data {
  padding: 24px 16px;
  opacity: 0.5;
  font-style: italic;
}
</style>